// cookie compliance banner
export function cookieCompliance() {
    if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
        document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
            e.preventDefault();

            e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

            window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
        });
    }

    if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
        document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
            e.preventDefault();

            e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
        });
    }
}